import styled from 'styled-components';

export const StyledIconContainer = styled.div`
    padding: ${({ theme: { space } }) => `${space[4]}`};
`;
